import { render, staticRenderFns } from "./Wise.vue?vue&type=template&id=36107abd&"
import script from "./Wise.vue?vue&type=script&lang=js&"
export * from "./Wise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports